import { render, staticRenderFns } from "./c-contructor-tab@.vue?vue&type=template&id=9be45eca&"
import script from "./c-contructor-tab@.vue?vue&type=script&lang=ts&"
export * from "./c-contructor-tab@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports